import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import ReduceAlcoholBGForm from './ReduceAlcoholBGForm'
import ReduceAlcoholBGView from './ReduceAlcoholBGView'
import { useForm, Controller } from 'react-hook-form'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { startLoading, doneLoading } from '../../../../utils/loading'
import { getSchemaSidebar } from '../../../../redux/actions/sidebar'
import { updateForm1, saveForm1 } from '../../../../redux/actions/background'
import ButtonPanel from '../../../ButtonPanel'
import WhisperMoreContent from '../../../WhisperMoreContent'
import WarningMessage from '../../../../components/message/WarningMessage/WarningMessage'

export default function ReduceAlcoholBGWidget(props) {
  const { showCommandButton, schema, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [formSchema, setFormSchema] = useState(schema)
  // const [formSchema, setFormSchema] = useState(schemaMock)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const [moreContent, setMoreContent] = useState(true)
  const [moreContentBottom, setMoreContentBottom] = useState(true)

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response
      if (request.id) {
        console.log('call update.')
        response = await updateForm1(projectId, request)
      } else {
        console.log('call save.')
        response = await saveForm1(projectId, request)
      }

      console.log('response', response)

      if (response) {
        onChangeIsEdit(false)
        setFormSchema(response)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    const request = {
      id: formSchema.id,
      projectVersionId: projectId,
      censusHousehold: data.censusHousehold,
      realHousehold: data.realHousehold,
      censusPopulation: data.censusPopulation,
      realPopulation: data.realPopulation,
      alcoholDrinkProvince: data.alcoholDrinkProvince,
      ranking: data.ranking,
      alcoholProblem: data.alcoholProblem,
      lowCount: data.lowCount,
      normalCount: data.normalCount,
      highCount: data.highCount,
      drinkerDatasource: data.drinkerDatasource,
      allComplyAct: data.allComplyAct,
      someComplyAct: data.someComplyAct,
      neverComplyAct: data.neverComplyAct,
      festivals: data.annualFestival,
      alcoholDrinkingProblems: data.alcoholDrinkingProblems,
      alcoholDrinkingFight: data.alcoholDrinkingFight,
      alcoholDrinkingAccident: data.alcoholDrinkingAccident,
      alcoholDrinkingIllness: data.alcoholDrinkingIllness,
      alcoholDrinkingDebt: data.alcoholDrinkingDebt,
      alcoholDrinkingDetail: data.alcoholDrinkingDetail,
      joinNganBoonEvents: data.joinNganBoon,
      joinNganBoonOtherEvents: data.joinNganBoonOtherEvents,
      singleNganBoonEvents: data.singleNganBoon,
      singleNganBoonOtherEvents: data.singleNganBoonOtherEvents,
      alcoholProblemSolution: data.alcoholProblemSolution,
      alcoholProblemSubject: data.alcoholProblemSubject,
      alcoholProblemSolving: data.alcoholProblemSolving,
      alcoholProblemSolveResult: data.alcoholProblemSolveResult,
      strengthWeakness: data.strengthWeakness,
      village: data.village,
      province: data.province,
      district: data.district,
      subDistrict: data.subDistrict,
    }

    console.log('request', request)
    handleCallService(request)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      <WarningMessage style={{ marginTop: -10 }} message={formSchema?.feedbackBySubject} />

      {moreContent && <div dangerouslySetInnerHTML={{ __html: formSchema.introduction }} />}

      <div style={{ textAlign: 'center', marginTop: '10px' }}>
        <WhisperMoreContent
          isShow={moreContent}
          onClick={() => {
            setMoreContent(!moreContent)
          }}
        />
      </div>

      {isEdit && showCommandButton ? (
        <ReduceAlcoholBGForm
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
        />
      ) : (
        <ReduceAlcoholBGView schema={formSchema} />
      )}

      {/* <div style={{ textAlign: 'center' }}>
        <WhisperMoreContent
          isShow={moreContent}
          onClick={() => {
            setMoreContentBottom(!moreContentBottom)
          }}
        />
      </div>

      {moreContentBottom && <div dangerouslySetInnerHTML={{ __html: formSchema.footer }} />} */}

      {showCommandButton && (
        <>
          <hr />
          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={formSchema.buttonText || 'ความเป็นมาหลักการและเหตุผล'}
            onSave={handleSubmit(onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </>
      )}
    </Panel>
  )
}
